export const BLOG_POSTS = [
  {
    slug: "shipping-production-llm-apps",
    title: "Shipping Production LLM Apps Without the 3AM Pages",
    excerpt: "The seven engineering disciplines that separate a demo from a system regulated industries can rely on.",
    category: "AI Engineering",
    date: "Nov 18, 2025",
    readTime: "9 min read",
    cover: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    author: "Ananya Verma",
    role: "Principal AI Engineer",
  },
  {
    slug: "design-systems-that-scale",
    title: "Design Systems That Scale Past 100 Engineers",
    excerpt: "Tokens, primitives, recipes — and the governance model that keeps everything from drifting six months in.",
    category: "Design",
    date: "Nov 4, 2025",
    readTime: "7 min read",
    cover: "https://images.unsplash.com/photo-1496181133206-80ce9b88a853?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    author: "Rohit Iyer",
    role: "Head of Design",
  },
  {
    slug: "event-driven-mes-manufacturing",
    title: "Event-Driven MES: A Field Report from the Factory Floor",
    excerpt: "Lessons from rebuilding a manufacturing execution system on Kafka — and the three traps to avoid.",
    category: "Architecture",
    date: "Oct 22, 2025",
    readTime: "12 min read",
    cover: "https://images.unsplash.com/photo-1686061594225-3e92c0cd51b0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    author: "Devansh Kapoor",
    role: "Distinguished Engineer",
  },
  {
    slug: "rag-eval-frameworks",
    title: "RAG Evaluation: Beyond 'It Looks Good in the Demo'",
    excerpt: "The metrics, eval sets and CI patterns we use to keep retrieval-augmented generation from regressing.",
    category: "AI Engineering",
    date: "Oct 8, 2025",
    readTime: "11 min read",
    cover: "https://images.unsplash.com/photo-1686061592689-312bbfb5c055?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    author: "Priya Nair",
    role: "ML Platform Lead",
  },
  {
    slug: "react-native-vs-native-2026",
    title: "React Native vs. Native in 2026: A Decision Framework",
    excerpt: "When the hybrid stack wins, when it loses and the seven questions that decide the answer for your product.",
    category: "Mobile",
    date: "Sep 24, 2025",
    readTime: "8 min read",
    cover: "https://images.unsplash.com/photo-1526657782461-9fe13402a841?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    author: "Marcus Wei",
    role: "Mobile Engineering Lead",
  },
  {
    slug: "core-web-vitals-tactics",
    title: "Eight Core Web Vitals Tactics That Actually Move INP",
    excerpt: "Real measurements, real diffs and the trade-offs we accepted to land LCP under 1.2s on a B2B SaaS.",
    category: "Web Performance",
    date: "Sep 11, 2025",
    readTime: "6 min read",
    cover: "https://images.unsplash.com/photo-1487017159836-4e23ece2e4cf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    author: "Sara Lindqvist",
    role: "Web Performance Lead",
  },
  {
    slug: "annotation-quality-playbook",
    title: "The Annotation Quality Playbook We Use Across 10M Labels",
    excerpt: "Consensus, golden sets, calibration drift and the dashboard every annotation lead should be staring at.",
    category: "Data",
    date: "Aug 28, 2025",
    readTime: "10 min read",
    cover: "https://images.unsplash.com/photo-1526628953301-3e589a6a8b74?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    author: "Hina Kapoor",
    role: "Data Operations Lead",
  },
  {
    slug: "ai-cost-engineering",
    title: "Cutting LLM Bills 64% Without Quality Regression",
    excerpt: "Routing, caching, quantization and the boring infrastructure work that compounds across millions of calls.",
    category: "AI Engineering",
    date: "Aug 14, 2025",
    readTime: "9 min read",
    cover: "https://images.unsplash.com/photo-1471897488648-5eae4ac6686b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    author: "Jonas Berg",
    role: "AI Platform Architect",
  },
];

export const BLOG_CATEGORIES = ["All", "AI Engineering", "Design", "Architecture", "Mobile", "Web Performance", "Data"];
